import { render, staticRenderFns } from "./popup_content_icon_text.vue?vue&type=template&id=a1d51ef0&lang=pug"
import script from "./popup_content_icon_text.vue?vue&type=script&lang=js"
export * from "./popup_content_icon_text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports